import state from './helppage.state'
import mutations from './helppage.mutations'
import actions from './helppage.actions'

export default {
  state,
  mutations,
  actions
}
